module.exports = __webpack_public_path__ + "img/yellow.857d228a.png";